import { BusinessLocation, LeanBusinessLocation } from './BusinessLocation';
import { LeanUser } from './User';

export interface IProviderReviewOption {
    id: number;
    text: string;
    result_type: string;
    is_active: boolean;
    show_on_positive_reviews: boolean;
    show_on_negative_reviews: boolean;
    is_positive: boolean;
    is_negative: boolean;
    positive_additional_info: string;
    negative_additional_info: string;
}

export const PROGRAM_IMPACT_RESULT_TYPE = 'ProgramImpact';

export function isProgramImpactOption(option: IProviderReviewOption): boolean {
    return option.result_type === PROGRAM_IMPACT_RESULT_TYPE;
}

export interface IProviderReviewAnswer extends IProviderReviewOption {
    value: boolean;
}

export interface IProvider {
    id: number;
    user: {
        id: number;
        first_name: string;
        last_name: string;
        profile_picture: {
            image: string;
        };
    };
}

export interface ILoadResponse {
    provider: IProvider;
    completed: boolean;
    options: IProviderReviewOption[];
    locations: BusinessLocation[];
    can_review: boolean;
}

export interface IProviderReview {
    id: number;
    reviewee: LeanUser;
    reviewer: {
        id: number;
        first_name: string;
        last_name: string;
        business?: {
            id: number;
            name: string;
        };
    };
    text: string;
    total_score: number;
    review_results: {
        id: number;
        option: IProviderReviewOption;
        value?: number;
    }[];
    completed_at: string;
    last_updated: string;
    added_at: string;
    business_location: LeanBusinessLocation;
}

export interface ProviderReviewSubmitResponse {
    id: number;
    text: string;
    total_score: number;
    review_results: {
        id: number;
        option: number;
    }[];
}
